'use strict';

var index = require('../../function-bind/index.js');

var bind = index;

var src = bind.call(Function.call, Object.prototype.hasOwnProperty);

module.exports = src;
